// Analisis data kota untuk subsistem animasi: arah aliran sungai & jalur perahu, landasan pacu terbesar.

// Sungai/air: water = ["x,y", ...]. Arah aliran GLOBAL: sumbu dengan bentang terpanjang
// (sungai lebar punya tetangga air di kedua sumbu, jadi deteksi per-tile tidak bisa diandalkan).
// Mengalir ke arah "bawah" layar: sumbu x → kanan-bawah, sumbu y → kiri-bawah.
// Jalur tengah sungai untuk perahu (bolak-balik mengikuti arah aliran):
// lane = sumbu tengah sungai (fraksional, pusat tile = lane+0.5); half = setengah lebar
// sungai yang aman untuk menyebar lajur perahu (0 bila sungai hanya 1 tile).
export function analyzeWater(waterSet) {
  const waterTiles = [];
  let minWX = Infinity, maxWX = -Infinity, minWY = Infinity, maxWY = -Infinity;
  for (const key of waterSet) {
    const [wx, wy] = key.split(",").map(Number);
    waterTiles.push({ x: wx, y: wy });
    if (wx < minWX) minWX = wx; if (wx > maxWX) maxWX = wx;
    if (wy < minWY) minWY = wy; if (wy > maxWY) maxWY = wy;
  }
  const axis = (maxWX - minWX) >= (maxWY - minWY) ? "x" : "y";
  let boatLane = null;
  if (waterTiles.length) {
    const across = axis === "x" ? [minWY, maxWY] : [minWX, maxWX];
    boatLane = {
      axis,
      lo: axis === "x" ? minWX : minWY,
      hi: axis === "x" ? maxWX : maxWY,
      lane: (across[0] + across[1]) / 2,
      half: Math.max(0, (across[1] - across[0] + 1) / 2 - 0.45)
    };
  }
  return { waterTiles, axis, boatLane };
}

// Info landasan untuk animasi pesawat — pakai KOMPONEN landasan TERBESAR
// (agar cabang/landasan kecil yang menyentuh tidak mengacaukan sumbu & ujung).
export function analyzeRunway(runwaySet) {
  if (!runwaySet.size) return null;
  // pecah menjadi komponen terhubung, ambil yang terbesar
  const seen = new Set();
  let best = null;
  for (const key of runwaySet) {
    if (seen.has(key)) continue;
    const [sx, sy] = key.split(",").map(Number);
    const stack = [[sx, sy]]; const comp = [];
    seen.add(key);
    while (stack.length) {
      const [x, y] = stack.pop();
      comp.push([x, y]);
      for (const [nx, ny] of [[x+1,y],[x-1,y],[x,y+1],[x,y-1]]) {
        const k = nx + "," + ny;
        if (runwaySet.has(k) && !seen.has(k)) { seen.add(k); stack.push([nx, ny]); }
      }
    }
    if (!best || comp.length > best.length) best = comp;
  }
  if (!best || !best.length) return null;
  let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
  for (const [x, y] of best) {
    if (x < minX) minX = x; if (x > maxX) maxX = x;
    if (y < minY) minY = y; if (y > maxY) maxY = y;
  }
  const alongX = (maxX - minX) >= (maxY - minY);
  // garis tengah pita (fraksional), ujung-ujung landasan
  const midC = alongX ? Math.round((minY + maxY) / 2) + 0.5 : Math.round((minX + maxX) / 2) + 0.5;
  const lo = alongX ? minX : minY, hi = alongX ? maxX + 1 : maxY + 1; // ujung (fraksional tile)
  return { axis: alongX ? "x" : "y", midC, lo, hi };
}
